import { useState } from "react";
import Marquee from "react-fast-marquee";
import { REFERENCES } from "@/lib/data";
import { Reveal } from "@/components/Reveal";
import ReferenceModal from "@/components/ReferenceModal";

function LogoChip({ name, image, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="group relative mx-3 flex h-24 w-52 shrink-0 cursor-pointer items-center justify-center overflow-hidden rounded-2xl border border-ink/5 bg-white shadow-sm outline-none transition-[filter,box-shadow,transform] duration-500 hover:scale-105 hover:shadow-[0_10px_30px_rgba(32,32,32,0.08)] focus-visible:ring-2 focus-visible:ring-orange/60 sm:mx-4 sm:h-28 sm:w-60"
      aria-label={`${name} referans detayı`}
    >
      <img
        src={image}
        alt={name}
        className="h-full w-full object-contain p-3 transition-transform duration-500 group-hover:scale-110"
        draggable={false}
      />
      {/* Shimmer overlay */}
      <div className="pointer-events-none absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/80 to-transparent opacity-0 transition-all duration-1000 ease-in-out group-hover:translate-x-full group-hover:opacity-100" />
    </button>
  );
}

export default function References() {
  const [activeRef, setActiveRef] = useState(null);

  return (
    <section id="referanslar" className="scroll-mt-24" data-testid="references">
      <div className="container-shell">
        <Reveal className="max-w-2xl text-center md:text-left">
          <p className="overline">Referanslarımız</p>
          <h2 className="heading-lg mt-4">
            <span className="text-ink">5000+</span>{" "}
            <span className="text-orange">referansımızdan</span>{" "}
            <span className="text-ink">bazıları.</span>
          </h2>
        </Reveal>
      </div>

      {/* Infinite marquee */}
      <div className="relative mt-10">
        <div className="pointer-events-none absolute left-0 top-0 z-10 h-full w-24 bg-gradient-to-r from-white to-transparent md:w-40" />
        <div className="pointer-events-none absolute right-0 top-0 z-10 h-full w-24 bg-gradient-to-l from-white to-transparent md:w-40" />
        <Marquee speed={40} gradient={false} pauseOnHover>
          {REFERENCES.map((r) => (
            <LogoChip
              key={r.name}
              name={r.name}
              image={r.image}
              onClick={() => setActiveRef(r)}
            />
          ))}
        </Marquee>
      </div>

      <ReferenceModal item={activeRef} onClose={() => setActiveRef(null)} />
    </section>
  );
}
